/* Print Lab — product/collection enhancements:
   (1) collapse product details into accordions (short buy box);
   (2) breadcrumbs + BreadcrumbList JSON-LD on product + collection pages (SEO + wayfinding).
   No-ops where the target containers aren't present. */
(function () {
  function makeAcc(title, html, open) {
    var d = document.createElement('details');
    d.className = 'pl-acc';
    if (open) d.open = true;
    var s = document.createElement('summary');
    s.className = 'pl-acc__sum';
    s.innerHTML = '<span>' + title + '</span><span class="pl-acc__ic" aria-hidden="true"></span>';
    var b = document.createElement('div');
    b.className = 'pl-acc__body rte';
    b.innerHTML = html;
    d.appendChild(s);
    d.appendChild(b);
    return d;
  }
  function initAccordions() {
    var info = document.querySelector('.product__info-container');
    if (!info || info.dataset.plAcc) return;
    info.dataset.plAcc = '1';
    var desc = info.querySelector('.product__description');
    var descHtml = desc ? desc.innerHTML.trim() : '';
    if (desc) desc.remove();
    var wrap = document.createElement('div');
    wrap.className = 'pl-accs';
    if (descHtml) wrap.appendChild(makeAcc('Product details', descHtml, false));
    wrap.appendChild(makeAcc('Shipping &amp; returns', '<p>Printed and shipped to order. We ship nationwide and worldwide. Free shipping on orders over $100. Easy 30-day returns on stock items.</p>', false));
    wrap.appendChild(makeAcc('Made in Memphis', '<p>Every order is printed by hand in-house on heavyweight blanks. No drop-shipping, no middleman.</p>', false));
    info.appendChild(wrap);
  }
  function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function initBreadcrumbs() {
    if (document.querySelector('.pl-bc')) return;
    var path = location.pathname.replace(/\/$/, '') || '/';
    var crumbs = null;
    if (/^\/products\//.test(path) || /\/products\//.test(path)) {
      var name = document.title.replace(/\s*[–|\-]\s*Print Lab\s*$/i, '').trim();
      crumbs = [{ n: 'Home', u: '/' }, { n: 'Shop', u: '/collections/all' }, { n: name, u: location.pathname }];
    } else if (/^\/collections\/[^/]+$/.test(path)) {
      var h = document.querySelector('.collection-hero__title, h1');
      var cn = h ? h.textContent.replace(/^\s*Collection:\s*/i, '').trim() : document.title.split('–')[0].trim();
      crumbs = [{ n: 'Home', u: '/' }, { n: cn, u: location.pathname }];
    }
    if (!crumbs) return;
    // BreadcrumbList JSON-LD
    var ld = { '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: crumbs.map(function (c, i) { return { '@type': 'ListItem', position: i + 1, name: c.n, item: location.origin + c.u }; }) };
    var sc = document.createElement('script'); sc.type = 'application/ld+json'; sc.textContent = JSON.stringify(ld); document.head.appendChild(sc);
    // visible trail
    var nav = document.createElement('nav'); nav.className = 'pl-bc'; nav.setAttribute('aria-label', 'Breadcrumb');
    nav.innerHTML = '<div class="pl-bc__in">' + crumbs.map(function (c, i) {
      return i < crumbs.length - 1 ? '<a href="' + c.u + '">' + esc(c.n) + '</a><span class="pl-bc__sep" aria-hidden="true">/</span>' : '<span class="pl-bc__cur" aria-current="page">' + esc(c.n) + '</span>';
    }).join('') + '</div>';
    var main = document.querySelector('#MainContent') || document.querySelector('main');
    if (main) main.insertBefore(nav, main.firstChild);
  }
  function sizeCustomizeBtn() {
    var b = document.getElementById('qstomizer-product-button');
    if (!b) return;
    if (b.style.fontSize !== '18px') b.style.setProperty('font-size', '18px', 'important');
    var s = b.querySelector('span');
    if (s && s.style.fontSize !== '18px') s.style.setProperty('font-size', '18px', 'important');
  }
  function init() { initAccordions(); initBreadcrumbs(); sizeCustomizeBtn(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  // Qstomizer ships a tiny 12px inline font-size on its button; bump it to read like the buy-box buttons (re-renders async, so observe).
  try { new MutationObserver(sizeCustomizeBtn).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();
